import React from "react";
export default function Icon(props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_719_803)">
<path d="M8.5 0C3.80375 0 0 3.80375 0 8.5C0 13.1962 3.80375 17 8.5 17C13.1962 17 17 13.1962 17 8.5C17 3.80375 13.1962 0 8.5 0ZM8.47875 15.81C4.44833 15.81 1.18292 12.5446 1.18292 8.51417C1.18292 4.48375 4.44833 1.21833 8.47875 1.21833C12.5092 1.21833 15.7746 4.48375 15.7746 8.51417C15.7746 12.5446 12.5092 15.81 8.47875 15.81ZM7.79167 13.4583H9.20833V11.3333H7.79167V13.4583ZM8.5 3.54167C6.89917 3.54167 5.48958 4.86625 5.48958 6.375H6.90625C6.90625 5.63125 7.66417 4.95833 8.5 4.95833C9.37833 4.95833 9.91667 5.41875 9.91667 5.66667C9.91667 7.3525 7.79167 7.65 7.79167 10.625H9.20833C9.20833 8.18833 11.3333 8.10333 11.3333 5.66667C11.3333 4.49083 10.0654 3.54167 8.5 3.54167Z" fill="#1D1D1D"/>
</g>
<defs>
<clipPath id="clip0_719_803">
<rect width="17" height="17" fill="white"/>
</clipPath>
</defs>
</svg>


  );
}
